import { useCallback, useEffect, useEffectEvent, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { fetchNegociacaoMarcos } from '../store/actions';
import {
  selectMarcosCarregando,
  selectMarcosNextCursor,
  selectMarcosViewState,
} from '../store/selectors';

export function useNegociacaoMarcos(caseId: string | null | undefined) {
  const dispatch = useAppDispatch();
  const viewState = useAppSelector(selectMarcosViewState);
  const nextCursor = useAppSelector(selectMarcosNextCursor);
  const carregando = useAppSelector(selectMarcosCarregando);
  const [sentinel, setSentinel] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!caseId) return;
    void dispatch(fetchNegociacaoMarcos({ caseId }));
  }, [dispatch, caseId]);

  const carregarProximaPagina = useEffectEvent(() => {
    if (!caseId || carregando || !nextCursor) return;
    void dispatch(fetchNegociacaoMarcos({ caseId, cursor: nextCursor }));
  });

  useEffect(() => {
    if (!sentinel || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        carregarProximaPagina();
      }
    });

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [sentinel]);

  const tentarNovamente = useCallback(() => {
    if (!caseId) return;
    void dispatch(fetchNegociacaoMarcos({ caseId }));
  }, [dispatch, caseId]);

  return { viewState, sentinelRef: setSentinel, tentarNovamente };
}
